/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const VimeoVIconConfig = {
  name: 'VimeoVIcon',
  height: 512,
  width: 448,
  svgPath: 'M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(VimeoVIconConfig);